import React, { useEffect, useState } from 'react';
import { Typography, Box, Skeleton } from '@mui/material';
import styles from './HomePage.module.css';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import {
  IconPackageExport,
  IconArrowRight,
  IconFileTime,
  IconChartAreaLine,
  IconDatabase,
  IconCar,
  IconTractor,
  IconUsers,
  IconRepeat,
  IconTrendingUp,
  IconHistory,
  IconHeartHandshake,
  IconSnowflake,
  IconClipboardList,
  IconForms,
  IconCloudStorm,
  IconWind,
  IconCloudRain,
  IconThermometer,
  IconSun,
  IconCalendar,
  IconFileText,
  IconBell,
  IconRoute,
  IconChartBar,
  IconCalculator,
  IconArrowsExchange,
  IconMapPin,
  IconMessageCircle,
  IconFileAnalytics,
  IconBriefcase,
  IconFolder,
  IconCurrencyDollar,
  IconChartPie,
  IconWalk,
  IconCloud,
  IconQuestionMark,
  IconSettings,
  IconRoute2,
  IconPlugConnected,
  IconBox,
  IconTruck,
  IconClipboard,
  IconPlus,
  IconCheckupList
} from '@tabler/icons-react';
import api from '../../authentication/axiosInstance';
import bgImage from '../../assets/dashboard-page-4.jpg';
import fleetioLogo from '../../assets/fleetio.png';
import bambooLogo from '../../assets/bamboo-grey.png';
import viaesysLogo from '../../assets/viaesys.png';
import jotformLogo from '../../assets/jotform.png';
import samsaraLogo from '../../assets/samsara.png';
import weatherworksLogo from '../../assets/weatherworks.svg';
import jdlinkLogo from '../../assets/jdlink.png';
import { message } from 'antd';
import moment from 'moment-timezone';

const HomePage = () => {
  const navigate = useNavigate();
  const [allocateExpanded, setAllocateExpanded] = useState(false);
  const [dispatchExpanded, setDispatchExpanded] = useState(false);
  const [databasesExpanded, setDatabasesExpanded] = useState(false);
  const [debriefExpanded, setDebriefExpanded] = useState(false);
  const [messages, setMessages] = useState([]);
  const [dispatchLogs, setDispatchLogs] = useState([]);
  const [latestStorm, setLatestStorm] = useState({});
  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
  });
  const [clientCareExpanded, setClientCareExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState({
    weather: false,
    sites: false,
    integrations: false
  });
  const [weatherData, setWeatherData] = useState({});
  const [events, setEvents] = useState({});
  const [autoSwitchInterval] = useState(5000); // 5 seconds per region
  const [integrations,setIntegrations] = useState(null); // 5 seconds per region

  function timeOfDayGreeting() {
    const currentTime = new Date().getHours();
    let greeting;
    if (currentTime < 12) {
      greeting = "Good Morning";
    } else if (currentTime < 18) {
      greeting = "Good Afternoon";
    } else {
      greeting = "Good Evening";
    }
    return greeting;
  }

  const fetchLatestStorm = async () => {
    try {
      await api.get('/dispatch/storm/latest/').then((response) => {
        setLatestStorm(response.data);
      });
    } catch (error) {
      console.error('Error fetching latest created storm:', error);
      message.error('Error fetching latest created storm');
    }
  }

  useEffect(() => {
    fetchMessages()
    fetchDispatchLogs()
  },[latestStorm])

  const fetchMessages = async () => {
    console.log(latestStorm.storm_id)
    try {
      await api.get('/dispatch/warning_messages/statuses_counter/', {
        params: {
          stormId: latestStorm.storm_id,
        }
      }).then((response) => {
        setMessages(response.data);
      });
     
    } catch (error) {
      console.error('Error fetching messages:', error);
      message.error('Failed to fetch messages');
    }
  };

  const fetchDispatchLogs = async () => {
    try {
      
      // Create an array of API requests for each type
      const [loaderLogs, walkwayLogs, saltingLogs] = await Promise.all([
        api.get("/dispatch/dispatchLogs/Walkway/counter/", {
          params : {
            stormId: latestStorm.storm_id
          }
        }),
        api.get("/dispatch/dispatchLogs/Salting/counter/", {
          params : {
            stormId: latestStorm.storm_id
          }
        }),
        api.get("/dispatch/dispatchLogs/Loader/counter/", {
          params : {
            stormId: latestStorm.storm_id
          }
        }),
      ]);
      
      const combinedLogs = {
        Unread: loaderLogs.data.unread + walkwayLogs.data.unread + saltingLogs.data.unread,
        Confirmed: loaderLogs.data.confirmed + walkwayLogs.data.confirmed + saltingLogs.data.confirmed,
        Denied: loaderLogs.data.denied + walkwayLogs.data.denied + saltingLogs.data.denied,
      }

      setDispatchLogs(combinedLogs);
    } catch (error) {
      console.error("Failed to fetch dispatch logs:", error);
      message.error("Failed to fetch dispatch logs");
      setDispatchLogs([]);
    }
  };

  const fetchUserConfig = async () => {

    setLoading(prev => ({ ...prev, integrations: true }));
    try {
      await api.get('/users/config/').then((response) => {
        setIntegrations(response.data)
      })

    } catch (error) {
      message.error('Failed to fetch user config');
    } finally {
      setLoading(prev => ({ ...prev, integrations: false }));
    }
  }

  const deleteConfig = async () => {

    try {
      await api.delete('users/config/').then((response) => {
        console.log(response.data)
      })
    } catch (error) {

    }
  }

  useEffect(() => {
    // deleteConfig()
    fetchUserConfig()
  },[])

  useEffect(() => {
    setIsLoading(true);
    try {
      fetchLatestStorm()
    } catch (error) {
      console.error('Error fetching data:', error);
      message.error('Failed to load some data');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data } = await api.get('/users/profile/');
        setUser({
          firstName: data.first_name,
          lastName: data.last_name,
        });
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUser();
  }, []);

  const MessageStatusCounter = ({ counts }) => {
    return (
      <div className={styles.messageStatusContainer}>
        <div className={styles.messageStatusRow}>
          <div className={styles.messageStatusItem} data-status="unread">
            <span className={styles.messageStatusLabel}>Unread</span>
            <span className={styles.messageStatusCount}>{counts.unread || 0}</span>
          </div>

          <div className={styles.messageStatusItem} data-status="confirmed">
            <span className={styles.messageStatusLabel}>Confirmed</span>
            <span className={styles.messageStatusCount}>{counts.confirmed || 0}</span>
          </div>

          <div className={styles.messageStatusItem} data-status="denied">
            <span className={styles.messageStatusLabel}>Denied</span>
            <span className={styles.messageStatusCount}>{counts.denied || 0}</span>
          </div>
        </div>
      </div>
    );
  };

  const ActionCard = ({ title, description, icon: Icon, isExpanded, onToggle, children }) => (
    <>
      <Box
        className={isExpanded ? styles.actionCardActive : styles.actionCard}
        onClick={onToggle}
        role="button"
        aria-expanded={isExpanded}
        tabIndex={0}
        onKeyPress={(e) => e.key === 'Enter' && onToggle()}
      >
        <Box className={styles.actionCardTopRow}>
          <Box className={isExpanded ? styles.actionCardTopRowLeftActive : styles.actionCardTopRowLeft}>
            <Icon size={24} />
            <Typography className={isExpanded ? styles.actionCardTitleActive : styles.actionCardTitle}>
              {title}
            </Typography>
          </Box>
          <Box className={styles.actionCardTopRowRight}>
            <IconArrowRight style={{ transform: isExpanded ? 'rotate(90deg)' : 'none', transition: 'transform 0.3s' }} />
          </Box>
        </Box>
        <Box className={isExpanded ? styles.actionCardBodyActive : styles.actionCardBody}>
          {description}
        </Box>
      </Box>
      {isExpanded && children}
    </>
  );

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const response = await api.get('/sites/site_regions/');
        setRegions(response.data);
        if (response.data.length > 0) {
          setSelectedRegion(response.data[0]);
        }
      } catch (error) {
        console.error('Error fetching regions:', error);
        message.error('Failed to fetch regions');
      }
    };
    fetchRegions();
  }, []);

  useEffect(() => {
    const fetchAllWeatherData = async () => {
      if (!regions.length) return;

      setLoading(prev => ({ ...prev, weather: true }));
      try {
        // Fetch Bolton data first as fallback
        const boltonWeather = await api.get('/weatherworks/forecast/Bolton/');
        const boltonEvents = await api.get('/weatherworks/fetch-events-by-region/Bolton/');

        const fallbackData = boltonWeather.data.success ? {
          ...boltonWeather.data.forecast,
          location: boltonWeather.data.location
        } : null;

        const fallbackEvents = boltonEvents.data.success ? boltonEvents.data.events : [];

        // Fetch data for all regions
        const weatherPromises = regions.map(region =>
          api.get(`/weatherworks/forecast/${region}/`)
            .catch(() => ({ data: { success: false } }))  // Handle individual region failures
        );
        const eventsPromises = regions.map(region =>
          api.get(`/weatherworks/fetch-events-by-region/${encodeURIComponent(region)}/`)
            .catch(() => ({ data: { success: false } }))  // Handle individual region failures
        );

        const weatherResponses = await Promise.all(weatherPromises);
        const eventsResponses = await Promise.all(eventsPromises);

        const weatherObj = {};
        const eventsObj = {};

        regions.forEach((region, index) => {
          if (weatherResponses[index].data.success) {
            weatherObj[region] = {
              ...weatherResponses[index].data.forecast,
              location: weatherResponses[index].data.location
            };
          } else if (fallbackData) {
            // Use Bolton data as fallback
            weatherObj[region] = fallbackData;
          }

          if (eventsResponses[index].data.success) {
            eventsObj[region] = eventsResponses[index].data.events || [];
          } else {
            // Use Bolton events as fallback
            eventsObj[region] = fallbackEvents;
          }
        });

        setWeatherData(weatherObj);
        setEvents(eventsObj);
      } catch (error) {
        console.error('Error fetching weather data:', error);
        message.error('Failed to fetch weather data');
      } finally {
        setLoading(prev => ({ ...prev, weather: false }));
      }
    };

    fetchAllWeatherData();
  }, [regions]);

  useEffect(() => {
    if (!regions.length) return;

    const interval = setInterval(() => {
      setSelectedRegion(currentRegion => {
        const currentIndex = regions.indexOf(currentRegion);
        const nextIndex = (currentIndex + 1) % regions.length;
        return regions[nextIndex];
      });
    }, autoSwitchInterval);

    return () => clearInterval(interval);
  }, [regions, autoSwitchInterval]);

  const getWindDirection = (degrees) => {
    const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
    const index = Math.round(degrees / 45) % 8;
    return directions[index];
  };

  const onAddIntegration = async (integrationType) => {
    try { 
      await api.post(`/users/config/${integrationType}/`).then((response) => {
        console.log(response.data)
      })
    } catch (error) {
      message.error('Error adding integration:', error);
    } finally {
      fetchUserConfig()
    }
  }

  const IntegrationInfo = ({ integrationName, integrationType, isIntegrated, navigateRoute }) => {
    return (
      <div className={styles.integrationInfoContainer}>
        <div className={styles.integrationInfo}>
          <h3>{integrationName}</h3>
          <p>Last synced: {integrations[integrationType].lastSync}</p>
        </div>
        {!isIntegrated ? (
          <div className={styles.integrationActions}>
            <button className={styles.addButton} onClick={() => onAddIntegration(integrationType)}>
              <IconPlus size={20} />
            </button>
          </div>
        ) : 
          <div className={styles.integrationActions}>
            <button className={styles.syncButton}>
              <IconRepeat size={20} />
            </button>
            <button className={styles.settingsButton}>
              <IconSettings size={20} onClick={() => navigate(navigateRoute)}/>
            </button>
         </div>  
        }
      </div>
    );
  }

  return (
    <div className={styles.main}>
      {/* Main Sections Grid */}
      <div className={styles.mainSectionsGrid}>
        {/* Plan Section */}
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>
              <IconClipboard size={24} />
              Plan
            </h2>
            <button className={styles.goToPageButton}>
              Go to Plan Page
              <IconArrowRight size={24} />
            </button>
          </div>
          <p className={styles.sectionDescription}>
          Prepare for the winter season by ensuring you have the proper tools to do the work. Connect to your fleet management system (Fleetio) and HR management software (Bamboo) to identify gaps in your resources. Estimate expenses, contract values and overall profitability based on weather, equipment and your portfolio.          </p>
          
          <div className={styles.subsection}>
            <h3>Operations</h3>
            <p>Allocate your equipment, staff and materials across your portfolio as you prepare for winter.</p>
            <div className={styles.iconCardsContainer}>
              <div>
                <div className={styles.card} onClick={() => navigate('/allocation')}>
                  <div className={styles.cardIcon}>
                    <IconTractor size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Loaders</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/walkwayCrew')}>
                  <div className={styles.cardIcon}>
                    <IconUsers size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Walkway Crews</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/SaltingRoute')}>
                  <div className={styles.cardIcon}>
                    <IconRoute size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Salting Routes</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/projection')}>
                  <div className={styles.cardIcon}>
                    <IconChartBar size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Project</div>
              </div>
            </div>
          </div>

          <div className={styles.subsection}>
            <h3>Customers</h3>
            <p>Organize client information, estimate service costs and schedule customized client reports.</p>
            <div className={styles.iconCardsContainer}>
              <div>
                <div className={styles.card} onClick={() => navigate('/estimatepage')}>
                  <div className={styles.cardIcon}>
                    <IconCalculator size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Estimates</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/clients')}>
                  <div className={styles.cardIcon}>
                    <IconUsers size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>CRM</div>
              </div>
            </div>
          </div>

          <div className={styles.subsection}>
            <h3>Analysis</h3>
            <p>Analyze your resource allocation, investigate automated recommendations and run reports.</p>
          </div>
        </div>

        {/* Execute Section */}
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>
              <IconTruck size={24} />
              Execute
            </h2>
            <button className={styles.goToPageButton} onClick={() => navigate('/execute')}>
              Go to Execute Page
              <IconArrowRight size={24} />
            </button>
          </div>
          <p className={styles.sectionDescription}>
          Optimize the Dispatch process for your team, organize client service requests, and communicate effectively with your management team.  Real-time equipment and staff integrations ensure that you are working with the most up to date information.          </p>

          <div className={styles.subsection}>
            <h3>Operations</h3>
            <p>Dispatch your crews and proactively communicate with your staff.</p>
            <div className={styles.iconCardsContainer}>
              <div>
                <div className={styles.card} onClick={() => navigate('/walkwayCrewDispatch')}>
                  <div className={styles.cardIcon}>
                    <IconUsers size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>{'Walkway\nCrews'}</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/SaltingRouteDispatch')}>
                  <div className={styles.cardIcon}>
                    <IconRoute2 size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>{'Salting\nRoutes'}</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/loaderDispatch')}>
                  <div className={styles.cardIcon}>
                    <IconTractor size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Loaders</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/dispatchHistory')}>
                  <div className={styles.cardIcon}>
                    <IconHistory size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>History</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/messages')}>
                  <div className={styles.cardIcon}>
                    <IconMessageCircle size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Messages</div>
              </div>
            </div>
          </div>

          <div className={styles.subsection}>
            <h3>Customers</h3>
            <p>Communicate storm strategies, organize client service requests and elicit client feedback.</p>
            <div className={styles.iconCardsContainer}>
              <div>
                <div className={styles.card} onClick={() => navigate('/bulk-storm-strategy')}>
                  <div className={styles.cardIcon}>
                    <IconCloud size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>{'Bulk\nStorm\nStrategy'}</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/storm-strategies')}>
                  <div className={styles.cardIcon}>
                    <IconHistory size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>{'Strategy\nHistory'}</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/storm-strategy-surveys')}>
                  <div className={styles.cardIcon}>
                    <IconQuestionMark size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>{'Survey\nResponses'}</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/requests')}>
                  <div className={styles.cardIcon}>
                    <IconSettings size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Requests</div>
              </div>
            </div>
          </div>

          <div className={styles.subsection}>
            <h3>Analysis</h3>
            <p>Utilize reporting features to summarize Dispatch and Client Request information for your team.</p>
          </div>
        </div>

        {/* Debrief Section */}
        <div className={`${styles.section} ${styles.debriefSection}`}>
          <div className={styles.sectionHeader}>
            <h2>
              <IconFileAnalytics size={24} />
              Debrief
            </h2>
            <button className={styles.exploreStatsButton}>
              <IconChartPie size={24} />
              Explore Stats
            </button>
          </div>
          <p className={styles.sectionDescription}>
          Explore the data that you've collected during the season so that you can improve your planning and execution next year. Utilize AI to actively engage with the data, ask questions and create insights that help to drive your success as a company.          </p>

          <div className={styles.subsection}>
            <h3>Explore</h3>
            <p>Dispatch your crews and proactively communicate with your staff.</p>
            <div className={styles.iconCardsContainer}>
              <div>
                <div className={styles.card} onClick={() => navigate('/debriefJobs')}>
                  <div className={styles.cardIcon}>
                    <IconBriefcase size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Jobs</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/projects')}>
                  <div className={styles.cardIcon}>
                    <IconFolder size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Projects</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/exploreJobs')}>
                  <div className={styles.cardIcon}>
                    <IconUsers size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Explore Jobs</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/jobsSummary')}>
                  <div className={styles.cardIcon}>
                    <IconCurrencyDollar size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Summary</div>
              </div>
              
              <div>
                <div className={styles.card} onClick={() => navigate('/historical-weather')}>
                  <div className={styles.cardIcon}>
                    <IconThermometer size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Weather History</div>
              </div>

              <div>
                <div className={styles.card} onClick={() => navigate('/staff-assessments')}>
                  <div className={styles.cardIcon}>
                    <IconCheckupList size={24} />
                  </div>
                </div>
                <div className={styles.cardLabel}>Staff Assessments</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Databases and Integrations Grid */}
      <div className={styles.databasesGrid}>
        {/* Databases Section */}
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>
              <IconBox size={24} />
              Databases
            </h2>
          </div>
          <div className={styles.iconCardsContainer}>
            <div>
              <div className={styles.card} onClick={() => navigate('/clients')}>
                <div className={styles.cardIcon}>
                  <IconUsers size={24} />
                </div>
              </div>
              <div className={styles.cardLabel}>Clients</div>
            </div>

            <div>
              <div className={styles.card} onClick={() => navigate('/sites')}>
                <div className={styles.cardIcon}>
                  <IconMapPin size={24} />
                </div>
              </div>
              <div className={styles.cardLabel}>Sites</div>
            </div>

            <div>
              <div className={styles.card} onClick={() => navigate('/vehicles')}>
                <div className={styles.cardIcon}>
                  <IconCar size={24} />
                </div>
              </div>
              <div className={styles.cardLabel}>Vehicles</div>
            </div>

            <div>
              <div className={styles.card} onClick={() => navigate('/equipments')}>
                <div className={styles.cardIcon}>
                  <IconTractor size={24} />
                </div>
              </div>
              <div className={styles.cardLabel}>Equipments</div>
            </div>

            <div>
              <div className={styles.card} onClick={() => navigate('/staff')}>
                <div className={styles.cardIcon}>
                  <IconUsers size={24} />
                </div>
              </div>
              <div className={styles.cardLabel}>Staff</div>
            </div>

            <div>
              <div className={styles.card} onClick={() => navigate('/storms')}>
                <div className={styles.cardIcon}>
                  <IconCloudStorm size={24} />
                </div>
              </div>
              <div className={styles.cardLabel}>Storms</div>
            </div>

            <div>
              <div className={styles.card} onClick={() => navigate('/subtypes')}>
                <div className={styles.cardIcon}>
                  <IconCar size={24} />
                </div>
              </div>
              <div className={styles.cardLabel}>{'Vehicle\nSubtypes'}</div>
            </div>
          </div>
        </div>

        {/* Integrations Section */}
        {integrations && 
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <h2>
                <IconPlugConnected size={24} />
                Integrations
              </h2>
            </div>
            <p className={styles.sectionDescription}>
              Integrate new apps to your service or manage the existing ones.
            </p>
            <div className={styles.integrationsContainer}>
              <div className={styles.integrationCard}>
                <div className={styles.integrationLogo}>
                  <img src={fleetioLogo} alt="Fleetio" />
                </div>
                <IntegrationInfo
                  integrationName="Fleetio"
                  integrationType='fleetio'
                  isIntegrated={integrations['fleetio'].enabled}
                  navigateRoute='/'
                />
              </div>

              <div className={styles.integrationCard}>
                <div className={styles.integrationLogo}>
                  <img src={bambooLogo} alt="Bamboo" />
                </div>
                <IntegrationInfo
                  integrationName="Bamboo"
                  integrationType='bamboo'
                  isIntegrated={integrations['bamboo'].enabled}
                  navigateRoute='/bambooSetting'
                />
              </div>

              <div className={styles.integrationCard}>
                <div className={styles.integrationLogo}>
                  <img src={viaesysLogo} alt="Viaesys" />
                </div>
                <IntegrationInfo
                  integrationName="Viaesys"
                  integrationType='viaesys'
                  isIntegrated={integrations['viaesys'].enabled}
                  navigateRoute='/'
                />
              </div>

              <div className={styles.integrationCard}>
                <div className={styles.integrationLogo}>
                  <img src={jotformLogo} alt="Jotform" />
                </div>
                <IntegrationInfo
                  integrationName="Jotform"
                  integrationType='jotform'
                  isIntegrated={integrations['jotform'].enabled}
                  navigateRoute='/jotformSetting'
                />
              </div>

              <div className={styles.integrationCard}>
                <div className={styles.integrationLogo}>
                  <img src={samsaraLogo} alt="Samsara" />
                </div>
                <IntegrationInfo
                  integrationName="Samsara"
                  integrationType='samsara'
                  isIntegrated={integrations['samsara'].enabled}
                  navigateRoute='/'
                />
              </div>

              <div className={styles.integrationCard}>
                <div className={styles.integrationLogo}>
                  <img src={weatherworksLogo} alt="WeatherWorks" />
                </div>
                <IntegrationInfo
                  integrationName="WeatherWorks"
                  integrationType='weatherWorks'
                  isIntegrated={integrations['weatherWorks'].enabled}
                  navigateRoute='/'
                />
              </div>

              <div className={styles.integrationCard}>
                <div className={styles.integrationLogo}>
                  <img src={jdlinkLogo} alt="JD Link" />
                </div>
                <IntegrationInfo
                  integrationName="JD Link"
                  integrationType='jdlink'
                  isIntegrated={integrations['jdlink'].enabled}
                  navigateRoute='/'
                />
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default HomePage;